import { css } from '@emotion/react';

// Styles pour la carte
export const cardStyles = css`
  width: 40%;
  max-width: 700px;
  padding: 64px;
  position: relative;
  z-index: 0;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  min-height: 600px;

  & > img {
    margin-top: 16px;
  }

  @media (max-width: 1900px) {
    width: 45%;
    padding: 48px;
  }

  @media (max-width: 1440px) {
    width: 55%;
    padding: 48px;
  }

  @media (max-width: 1024px) {
    width: 80%;
    padding: 48px;
  }

  @media (max-width: 768px) {
    width: 100%;
    min-height: 100vh;
    padding: 32px;
  }
`;

export const cardWrapperStyles = css`
  width: 100vw;
  height: 100vh;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-top: 50px;
  padding-bottom: 50px;

  @media (max-width: 768px) {
    padding: 0px;
  }
`;

// Séparateur "OR" avec lignes gris foncé à gauche et à droite
export const orSeparatorStyles = css`
  margin: 24px 0;
  width: 100%;
  display: flex;
  align-items: center;
  gap: 8px;
  color: #444; /* texte gris foncé */
  font-weight: 500;
  font-size: 0.875rem;

  &::before,
  &::after {
    content: '';
    flex: 1;
    border-bottom: 1px solid #444; /* lignes gris foncé */
    opacity: 0.8; /* léger adoucissement */
  }
`;
